import React from 'react';
import { Modal, ModalBody } from 'reactstrap';

const GuidelineVideoModal = ({ isModalOpen, setIsOpenModal, videoUrl }) => {
  return (
    <div className="guideline-video-modal-wrapper">
      {isModalOpen && (
        <Modal
          className="guideline-video-modal"
          isOpen={isModalOpen}
          toggle={() => setIsOpenModal((prev) => !prev)}
        >
          <ModalBody>
            <video
              className="guideline-video"
              src={videoUrl}
              controls
              autoPlay
              playsInline
              webkit-playsinline={true}
            />
          </ModalBody>
        </Modal>
      )}
    </div>
  );
};

export default GuidelineVideoModal;
